import template from './sw-cms-preview-acris-blog.html.twig';
import './sw-cms-preview-acris-blog.scss';

const { Component } = Shopware;

Component.register('sw-cms-preview-acris-blog', {
    template
});
